var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke-width:1.5px;}.a,.b{stroke:#353841;}.b,.d,.f{fill:none;}.b,.d{stroke-linecap:round;}.c{fill:#353841;}.d{stroke:#fff;stroke-width:1.3px;}.e{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-161 -924)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(161 924)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16,
    height: 19,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 17.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15161.169,13700.432h3.979",
    transform: "translate(-14997 -12774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15161.168,13700.432h9.52",
    transform: "translate(-14997 -12770)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15161.168,13700.432h9.52",
    transform: "translate(-14997 -12766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15161.168,13700.432h9.52",
    transform: "translate(-14997 -12768)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168 936)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2230.386,6409.655l2.15,2.149,3.689-3.688",
    transform: "translate(-2227.14 -6403.979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.e0e88c7e65504e57690b78b240b173e7.svg";
export { ForwardRef as ReactComponent };